import axios, { type AxiosInstance } from 'axios';

const DEFAULT_API_URL = 'http://localhost:3000';

/**
 * URL dell'API: **unica** fonte per il client, per le immagini degli eventi e
 * per gli upload (B5). In Docker arriva da `VITE_API_URL`, passato come build arg
 * (vedi `Dockerfile` e `docker-compose.yml`).
 */
export const API_URL: string = import.meta.env.VITE_API_URL?.trim() || DEFAULT_API_URL;

export const USER_STORAGE_KEY = 'movimento:user';
export const ADMIN_STORAGE_KEY = 'movimento:admin';

/**
 * Client HTTP.
 *
 * M4: il token JWT vive in un cookie `HttpOnly` e non è leggibile da JavaScript.
 * `withCredentials` abilita l'invio e la ricezione del cookie verso l'API; non c'è
 * più nessun header `Authorization` da costruire a mano.
 */
export const api: AxiosInstance = axios.create({
    baseURL: API_URL,
    timeout: 20000,
    withCredentials: true,
});

